import {Layout} from "./Layout.js";

export class SubDomainLayout extends  Layout {
    template() {
        const {sectionId = ''} = this.$props;
        return `
                <section id="${sectionId}" class="signup-wide-pop">
                    <header class="js-section-header"></header>
                    <article>
                        <div class="pop-main js-contents-main">
                            ${this.getMainTextTemplate()}
                            ${this.getSubTextTemplate()}
                            <div id="subDomainInputLayer" class="url-wrap"> </div>
                            ${this.getNexPageButtonTemplate()}
                            ${this.getInfoTextTemplate()}
                        </div>
                    </article>
                </section>`
    }

    getSubDomainInputLayer() {
        return $("#subDomainInputLayer");
    }
    getInfoTextTemplate() {
        const {infoText = ""} = this.$props;
        if(Mutil.empty(infoText)) {
            return '';
        }

        return `<p class="info-txt"><i class="sign-icons-exclamation"></i>${infoText}</p>`
    }
}